<div class="flex items-center mb-10 lg:mb-0">
	<img [src]="authorThumbnail" alt="Foto do autor" class="h-12 w-12 rounded-full object-cover" />
	<div class="flex flex-col items-start ml-2.5">
		<p class="body" *ngIf="post?.authorName">{{ post?.authorName }}</p>
		<p class="body-sm">{{ post?.createdDate | date: 'dd/MM/yyyy' }}</p>
	</div>
</div>
